/* import __COLOCATED_TEMPLATE__ from './creator-details.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-seller-applications-creator-details';

const CREATOR_LOCATION_CLASS_NAME = `${CLASS_NAME}__creator-location`;
const CREATOR_LAST_LOCATION_CLASS_NAME = `${CREATOR_LOCATION_CLASS_NAME}--last-location`;

class SellerApplicationsCreatorDetails extends Component {
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get lastLocationClassNames() {
    return clsx(
      CREATOR_LOCATION_CLASS_NAME,
      CREATOR_LAST_LOCATION_CLASS_NAME,
    );
  }

  get creatorName() {
    const { user } = this.args;
    const { currentUser } = this.session;

    // obfuscate creator name
    return !currentUser || currentUser.company?.isNeedsCreditCard
      ? user.fullNameSingleLastDigit
      : user.fullName;
  }
}

export default SellerApplicationsCreatorDetails;
